// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28Yyz","title":"styles_title__cmT7P"};